var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00002 13.8331C1.00002 14.7539 1.74585 15.4998 2.66669 15.4998H9.33335C10.2542 15.4998 11 14.7539 11 13.8331V3.83309H1.00002V13.8331ZM11.8334 1.33309H8.91669L8.08335 0.499756H3.91669L3.08335 1.33309H0.166687V2.99976H11.8334V1.33309Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteContactIcon);
export default __webpack_public_path__ + "static/media/delete-contact-icon.39f3065965a1b3543d3a2c8199b4102e.svg";
export { ForwardRef as ReactComponent };